import useServiceFactory from './serviceFactory'

const useCommonApi = () => {
   
    const service = useServiceFactory({uri: process.env.REACT_APP_API_URL + "api/app/"  });
    const serviceAbp = useServiceFactory({uri: process.env.REACT_APP_API_URL + "api/abp/"   });
    return {
        obtenerAsync: async <T>(sourceName: string, params?): Promise<T> => service.get(sourceName, {params}),
        obtenerAbpAsync: async <T>(sourceName: string, params?): Promise<T> => serviceAbp.get(sourceName, {params}),
        obtenerPorIdAsync: async <T>(sourceName: string, id: number | string): Promise<T> =>
            service.get(`${sourceName}/${id}/by-id`),
        obtener: <T>(sourceName: string, params?): Promise<T> => service.get(sourceName, {params}),
        postAsync: async <T>(sourceName: string, params?): Promise<T> => service.post(sourceName, params),
        putAsync: async <T>(sourceName: string, params?): Promise<T> => service.put(sourceName, params),
        obtenerAreaServicioPorCpAsync: async <T>(sourceName: string, params?): Promise<T> => service.get(sourceName, {params}),
    }
};

export default useCommonApi;
